module.exports = __webpack_public_path__ + "img/tahunajaran.055c5f9f.jpg";